// All reconciliation amount filters use the document amount plus this margin.
export const getConciliationAmountLimit = amount => {
  const numericAmount = Number(amount)
  return (Number.isFinite(numericAmount) ? Math.abs(numericAmount) : 0) + 1_000_000
}
